import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'wilsonTimelineShiftHeight',
  standalone: true,
})
export class TimelineShiftHeightPipe implements PipeTransform {
  //TODO: consider moving this back to the template if no more complexity is needed
  transform(
    innerRowHeight: number,
    numberOfInnerRows: number,
    defaultRowHeight: number,
  ): number {
    if (numberOfInnerRows <= 2) {
      return innerRowHeight > defaultRowHeight / 3
        ? innerRowHeight - 4
        : innerRowHeight - 2;
    } else {
      return innerRowHeight - 2;
    }
  }
}
